import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { sxToolbar } from '~/views/atoms/toolbar';
import { CloseButton } from 'src/views/molecules/dialog-buttons/close-button';
import React from 'react';
import { AppBar, Divider, Toolbar, Typography } from '@mui/material';
export const DialogTopBar = ({ title, closeButtonHandler }) => {
    return (_jsxs(AppBar, { color: "inherit", position: "relative", children: [_jsxs(Toolbar, { sx: sxToolbar, children: [_jsx(Typography, { variant: "h2", children: title }), _jsx(CloseButton, { closeButtonHandler: closeButtonHandler })] }), _jsx(Divider, {})] }));
};
